// extracted by mini-css-extract-plugin
module.exports = {"privacidade":"style_privacidade__3I6_z"};